import {useMutation} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {BackendResponse} from '../../http/backend-response/backend-response';
import {onFormQueryError} from '../../errors/on-form-query-error';
import {useNavigate} from '../../utils/hooks/use-navigate';
import {apiClient} from '../../http/query-client';
import {useAuth} from '../use-auth';
import {useBootstrapData} from '../../core/bootstrap-data/bootstrap-data-context';
import {getTrackingParametersFromCookie} from '../../utils/hooks/use-tracking-parameters';
import type {TrackingParameters} from '../../utils/hooks/use-tracking-parameters';

interface Response extends BackendResponse {
  bootstrapData?: string;
  message?: string;
  status: 'success' | 'needs_email_verification' | 'needs_phone_verification';
}

export interface RegisterPayload {
  email?: string;
  password?: string;
  password_confirmation?: string;
  phone?: string;
  tracking_parameters?: TrackingParameters;
}

export function useRegister(form: UseFormReturn<RegisterPayload>) {
  const navigate = useNavigate();
  const {getRedirectUri} = useAuth();
  const {setBootstrapData} = useBootstrapData();
  return useMutation({
    mutationFn: register,
    onSuccess: response => {
      setBootstrapData(response.bootstrapData!);
      if (response.status !== 'success') {
        navigate('/');
      } else {
        navigate(getRedirectUri(), {replace: true});
      }
    },
    onError: r => onFormQueryError(r, form),
  });
}

function register(payload: RegisterPayload): Promise<Response> {
    const trackingParameters = getTrackingParametersFromCookie();
    if (trackingParameters) {
      payload.tracking_parameters = trackingParameters;
    }
    return apiClient.post('auth/register', payload).then(response => response.data);
}
